'use strict';

module.exports = function() {
    return function(text) {
        if (text === undefined || text === null) return '';
        text = (text).replace(/(?:(?:^|\n)\s+|\s+(?:$|\n))/g, '').replace(/\s+/g, ' ');
        return String(text);
    };
};